export default "__VITE_ASSET__BXrha3$L__"